import { render, staticRenderFns } from "./SingleButton.vue?vue&type=template&id=8733ff58&scoped=true&"
import script from "./SingleButton.vue?vue&type=script&lang=js&"
export * from "./SingleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8733ff58",
  null
  
)

export default component.exports